export function bloquearCientifica(event: KeyboardEvent) {
    const teclasBloqueadas = ['e', 'E', '+', '-'];
    if (teclasBloqueadas.includes(event.key)) {
        event.preventDefault();
    }
}
